// extracted by mini-css-extract-plugin
module.exports = {"root":"Player_root__36CGP","clear":"Player_clear__ExF0g","add":"Player_add__1GVN9 Player_root__36CGP"};